import React from 'react';
import { NavItemIcon } from '@/domain/navigation/types';
import { RemoteIcon } from '@/experiences/shared/components/remote-icon';

interface NavIconProps {
  color: string;
  fallback?: React.ReactElement | null;
  icon?: NavItemIcon;
  iconUrl?: string;
  size: number;
}

/**
 * Resolves a nav item's icon in the order every nav surface agrees on:
 * named Sprout Kit icon, then remote icon URL, then the caller's fallback.
 */
export const NavIcon: React.FC<NavIconProps> = ({
  color,
  fallback = null,
  icon: Icon,
  iconUrl,
  size,
}) =>
  Icon ? (
    <Icon color={color} height={size} size={size} stroke={color} width={size} />
  ) : iconUrl ? (
    <RemoteIcon size={size} uri={iconUrl} />
  ) : (
    fallback
  );
